import { COMPONENT_TYPES } from '../../../constants';
import FixedBgTextComponent from './FixedBgText.component';
import FixedBgTextEditor from './FixedBgText.editor';
import FixedBgTextProperties from './FixedBgText.properties';
import { registerComponent } from '../registry';

// 레지스트리에 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.FIXED_BG_TEXT,
  component: FixedBgTextComponent,
  editorComponent: FixedBgTextEditor,
  properties: FixedBgTextProperties,
  defaultProps: {
    componentProps: {
      bgImageUrl: 'https://via.placeholder.com/1920x1080',
      overlayColor: '#000000',
      overlayOpacity: 0.5,
      textColor: '#ffffff',
      contentAlignment: 'center',
      height: 500
    },
    style: {
      width: '100%',
      margin: '0 auto',
      boxSizing: 'border-box',
      position: 'relative'
    },
    content: '<h2>멋진 배경 이미지 제목</h2><p>여기에 텍스트를 추가하세요.</p>'
  },
  category: 'content',
  icon: '🖼️',
  name: '고정 배경 텍스트'
});

// 컴포넌트 및 타입 내보내기
export { default as FixedBgTextComponent } from './FixedBgText.component';
export { default as FixedBgTextEditor } from './FixedBgText.editor';
export { default as FixedBgTextProperties } from './FixedBgText.properties';
export * from './FixedBgText.types'; 